import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@material-ui/styles';
import * as Sentry from '@sentry/react';

import 'perfect-scrollbar/css/perfect-scrollbar.css';

import App from './App';
import Notifications from './components/notifications/Notifications';
import Analytics from './components/analytics/Analytics';
import store from './store';
import theme from './theme';
import history from './history';
import polyfills from './utility/polyfills';
import './assets/common-style.css';

if ((process.env.REACT_APP_BUILD_ENV === 'production' ||process.env.REACT_APP_BUILD_ENV === 'staging' || process.env.REACT_APP_BUILD_ENV === 'development') && process.env.REACT_APP_SENTRY_RELEASE) {
  Sentry.init({
    dsn: 'https://e233154e939b49d19483fef35b292326@o435262.ingest.sentry.io/5394206',
    release: process.env.REACT_APP_SENTRY_RELEASE,
    environment: process.env.REACT_APP_BUILD_ENV || 'development',
  });
}

polyfills();

const root = (
  <Sentry.ErrorBoundary>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ThemeProvider theme={theme}>
          <Notifications />
          <App />
          <Analytics />
        </ThemeProvider>
      </ConnectedRouter>
    </Provider>
  </Sentry.ErrorBoundary>
);

ReactDOM.render(root, document.getElementById('root'));
